import { WSList, WSPanel, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { FlowMEChangeContext } from "..";
import { useQueryPrimaryComplianceEntity } from "../../../../../shared/hooks/useQueryPrimaryComplianceEntity";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { FormAccountType } from "../../../components/FormAccountType";
import { getProfileDataAccountType } from "../../../components/FormAccountType/getProfileDataAccountType";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { FlowStep } from "../../../../../shared/components/FlowSwitch/types";

export const StepMaterialUpdateAccountType: React.FC<FlowStep> = props => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();

  const queryCustomerEntity = useQueryPrimaryComplianceEntity();
  const queryFeatureFlags = useQueryFeatureFlags();
  const profileData = useMemo(
    () => getProfileDataAccountType(queryCustomerEntity.data),
    [queryCustomerEntity.data]
  );

  // These forms compute their defaults once, at mount, so the read the prefill
  // comes from has to have settled first — otherwise the fields stay empty.
  if (!queryCustomerEntity.isFetched) {
    return <WSPanel shimmer />;
  }

  return (
    <WSList gap="2XL">
      <FormAccountType
        accountTypes={["Individual", "Business"]}
        allowUSInternationalPerson={
          queryFeatureFlags.data?.internationalUsPerson
        }
        defaultValues={context.accountType || profileData}
        onSubmit={data => {
          setContext(prev => ({
            ...prev,
            accountType: data
          }));
          props.onNext?.();
        }}
        onChange={data => {
          setContext(prev => ({
            ...prev,
            accountType: data
          }));
        }}
        onBack={props.onBack}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
